module.exports = __webpack_public_path__ + "media/bg1.a2f1aeff.mp3";